// extracted by mini-css-extract-plugin
module.exports = {"yaContainer":"YaMapComponent_yaContainer__124Ay","yaContainerFixed":"YaMapComponent_yaContainerFixed__38oor"};